
import {Vue} from 'vue-class-component';
import {Prop} from "vue-property-decorator";

export default class RequestOutlineHeader extends Vue {
  @Prop() stepHeading!: string
}
